module.exports = __webpack_public_path__ + "static/media/covid_qr_p1_3.02a0d30f.png";